<template>
  <div v-loading.fullscreen.lock="loading" class="notice-detail">
    <!-- 头部 -->
    <top-part :rightPart="false">
      <template slot="title">公告通知</template>
    </top-part>

    <!-- 详情内容 -->
    <div class="detail-content" v-if="noticeDetail">
      <!-- 信息栏 -->
      <div class="detail-info">
        <div class="info-row">
          <span class="info-label">公告名称</span>
          <span class="info-value">{{ noticeDetail.title }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">公告类别</span>
          <span class="info-value">{{ noticeDetail.categoryName }}</span>
        </div>
        <div class="info-row">
          <span class="info-label">发布时间</span>
          <span class="info-value">{{
            noticeDetail.publishTime
          }}</span>
        </div>
      </div>

      <!-- 公告概述 -->
      <div class="section-title">公告概述</div>
      <div class="detail-body">
        <div v-if="noticeDetail.summary" class="detail-summary">
          {{ noticeDetail.summary }}
        </div>
      </div>
      <!-- 公告内容 -->
      <div class="section-title">公告内容</div>
      <div class="detail-body">
        <div
          v-if="noticeDetail.content"
          class="detail-text"
          v-html="noticeDetail.content"
        ></div>
      </div>
    </div>

    <!-- 空状态 -->
    <van-empty v-if="!loading && !noticeDetail" description="通知不存在" />
  </div>
</template>

<script>
import topPart from "../../components/topPart";
import { announcementDetail, announcementMarkAsRead } from "@/common/api";
import moment from "moment";

export default {
  components: {
    topPart,
  },
  data() {
    return {
      loading: true,
      noticeDetail: null,
      noticeId: "",
    };
  },
  mounted() {
    this.noticeId = this.$route.query.id;
    if (this.noticeId) {
      this.getNoticeDetail();
      this.markAsRead();
    } else {
      this.loading = false;
    }
  },
  methods: {
    // 获取通知详情
    getNoticeDetail() {
      announcementDetail({ id: this.noticeId })
        .then((res) => {
          this.loading = false;
          if (res.code == 200) {
            this.noticeDetail = res.data;
          } else {
            this.$toast(res.message || "获取详情失败");
          }
        })
        .catch(() => {
          this.loading = false;
          this.$toast("网络错误，请重试");
        });
    },

    // 标记为已读
    markAsRead() {
      announcementMarkAsRead({ id: this.noticeId }).then(() => {
        // 标记成功，无需处理
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
.notice-detail {
  background-color: #f5f5f5;
  min-height: 100vh;
}

.detail-content {
  margin-top: 45px;
  padding: 16px;
}

.detail-info {
  background: #fff;
  border-radius: 8px;
  margin-bottom: 16px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.info-row {
  display: flex;
  align-items: center;
  padding: 16px 20px;
  border-bottom: 1px solid #f0f0f0;

  &:last-child {
    border-bottom: none;
  }
}

.info-label {
  font-size: 15px;
  color: #333;
  width: 80px;
  flex-shrink: 0;
  font-weight: 500;
}

.info-value {
  font-size: 15px;
  color: #666;
  flex: 1;
}

.section-title {
  font-size: 16px;
  color: #333;
  font-weight: 600;
  margin: 20px 0 0 0;
  padding-left: 4px;
  border-left: 4px solid #1890ff;
  background: #fff;
  padding: 16px 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
}

.detail-body {
  background: #fff;
  padding: 20px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  margin-bottom: 16px;
}

.detail-summary {
  font-size: 15px;
  color: #666;
  line-height: 1.6;
  margin-bottom: 16px;
}

.detail-text {
  font-size: 15px;
  color: #666;
  line-height: 1.8;

  :deep(p) {
    margin-bottom: 12px;

    &:last-child {
      margin-bottom: 0;
    }
  }

  :deep(img) {
    max-width: 100%;
    height: auto;
    border-radius: 4px;
    margin: 8px 0;
  }
}

:deep(.van-empty) {
  padding: 60px 0;
}
</style>
